import type React from "react";
export const Loading: React.FC = () => <div className="lds-ellipsis" data-sentry-component="Loading" data-sentry-source-file="Loading.tsx">
    <div />
    <div />
    <div />
    <div />
  </div>;